export default __webpack_public_path__ + "static/media/main_saying02_kr.c1ec9bd3.png";